import React, { useState, useMemo } from 'react';
import '../../styles/EmailReminder.css';
import Switch from '../Switch';
import { useAuthStore } from '../../store/store';
import { getEmailPreference, updateEmailPreference, updateEmailReminders, getEmailReminders, getEmailReminderTime, updateEmailReminderTime } from '../../api/user';
import { calculateNextSendTime } from '../../api/reminders';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import Modal from 'react-bootstrap/Modal';
const moment = require('moment-timezone');
const time = moment().format('LT');

export default function EmailReminder() {
    const uid = useAuthStore(store => store.user?.uid);
    const [messageShow, setmessageShow] = useState('');
    const [reminderMessage, setReminderMessage] = useState(' ');
    const [showSaveModal, setShowSaveModal] = useState(false);
    const [reminders, setReminders] = useState({ time: '09:00', frequency: '', message: '', day: '' });
    const queryClient = useQueryClient();

    const emailReminderTimeQuery = useQuery({
        queryKey: ['getEmailReminderTime', uid],
        queryFn: () => getEmailReminderTime(uid),
        enabled: !(uid === null || uid === undefined),
    });

    const emailSubscriptionStatusQuery = useQuery({
        queryKey: ['getEmailPreference', uid],
        queryFn: () => getEmailPreference(uid),
        enabled: !(uid === null || uid === undefined),
    });

    const emailRemindersQuery = useQuery({
        queryKey: ['getEmailReminders', uid],
        queryFn: () => getEmailReminders(uid),
        enabled: !(uid === null || uid === undefined),
    });

    const { mutate: updateEmailRemindersStatus } = useMutation(updateEmailReminders, {
        onSuccess: () => {
            queryClient.invalidateQueries(['getEmailReminders', uid]);
            setmessageShow('success');
        },
    });
    const { mutate: updateEmailSubscriptionStatus } = useMutation(updateEmailPreference, {
        onSuccess: () => {
            queryClient.invalidateQueries(['getEmailPreference', uid]);
        },
    });

    const handleToggle = () => {
        updateEmailSubscriptionStatus({ isToggled: emailSubscriptionStatusQuery.data, uid });
    };

    const handleSave = async() => {
        if (reminders.time !== ''
            && reminders.frequency !== ''
            && reminders.message !== '') {
            updateEmailRemindersStatus({ reminder: reminders, uid });
            setReminderMessage('Your Reminder has been updated successfully!');
            setShowSaveModal(true);
        } else {
            setReminderMessage('Please fill out all field before saving');
            setmessageShow('error');
        }
        const reminderTime = calculateNextSendTime(reminders.time, reminders.frequency, reminders.day);
        updateEmailReminderTime({ reminderTime, uid });
    };

    const handleReminderChange = (e) => {
        setReminders({ ...reminders, [e.target.id]: e.target.value });
        setmessageShow('');
    };

    useMemo(() => {
        if (emailRemindersQuery.isSuccess && emailRemindersQuery.data !== null && emailRemindersQuery.data !== undefined) {
            setReminders(emailRemindersQuery.data);
            const reminderTime = calculateNextSendTime(emailRemindersQuery.data.time, emailRemindersQuery.data.frequency, emailRemindersQuery.data.day);
            updateEmailReminderTime({ reminderTime, uid });
        }
    }, [emailRemindersQuery.isSuccess, emailReminderTimeQuery.isSuccess, emailRemindersQuery.data, emailReminderTimeQuery.data, time]);

    return (
        <>
            <Modal
                show={showSaveModal}
                onHide={() => setShowSaveModal(false)}
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter" className='w-100 text-center p-2'>
                        Save Confirmation
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='d-flex justify-content-center align-items-center p-3'>
                        You have saved the reminder successfully!
                    </div>
                </Modal.Body>
                <Modal.Footer className='ps-4 pe-4'>
                    <div className='d-flex justify-content-end w-100'>
                        <button className='delete-modal btn-confirm py-2 px-3' onClick={() => { setShowSaveModal(false); }} >Confirm</button>
                    </div>
                </Modal.Footer>
            </Modal>
            <div className='email-reminder flex-grow-1 h-100 d-flex'>
                <div className="container-fluid h-100">
                    <div className='row'>
                        <div className='col-12'>
                            <div className='navigate-email justify-content-between'>
                                <h3>Subscribe to Daily Email Reminder</h3>
                                <Switch isToggled={emailSubscriptionStatusQuery.data || false} onToggle={handleToggle} />
                            </div>
                        </div>
                    </div>
                    {emailSubscriptionStatusQuery.data && emailReminderTimeQuery.data !== null
                        ? <div className='row'>
                            <div className='col-12'>
                                <div className='navigate-email justify-content-between'>
                                    <h3>
                                        {emailReminderTimeQuery.data[0] === 0 && emailReminderTimeQuery.data[1] === 0
                                            ? <span>
                                                Your next email would be sent in {emailReminderTimeQuery.data[2]} minutes
                                            </span>
                                            : emailReminderTimeQuery.data[0] === 0 ?
                                                <span>
                                                    Your next email would be sent in {emailReminderTimeQuery.data[1]} hours {emailReminderTimeQuery.data[2]} minutes
                                                </span>
                                                : <span>
                                                Your next email would be sent in {emailReminderTimeQuery.data[0]} days {emailReminderTimeQuery.data[1]} hours {emailReminderTimeQuery.data[2]} minutes
                                                </span>
                                        }
                                    </h3>
                                </div>
                            </div>
                        </div>
                        : null
                    }
                    {emailSubscriptionStatusQuery.data
                        ? <div>
                            {<div className='row'>
                                <div className='col-12'>
                                    <div className='remidner-card p-6 mb-3 pl-12 pr-12'>
                                        <h5>Email Reminder</h5>
                                        <div className='mb-3 row'>
                                            <div className='mb-3 col-md-4'>
                                                <label htmlFor='time-1' className='form-label'>Set Reminder Time</label>
                                                <input
                                                    type='time'
                                                    className='form-control input-field'
                                                    step='3600'
                                                    id='time'
                                                    value={reminders.time}
                                                    onChange={(e) => handleReminderChange(e)}
                                                />
                                            </div>
                                            <div className='mb-3 col-md-4 ml-4'>
                                                <label htmlFor='frequency' className='form-label'>Reminder Frequency</label>
                                                <select
                                                    className='form-select input-field'
                                                    id='frequency'
                                                    value={reminders.frequency}
                                                    onChange={(e) => handleReminderChange(e)}
                                                >
                                                    <option value=''>Select Frequency</option>
                                                    <option value='Daily'>Daily</option>
                                                    <option value='Weekly'>Weekly</option>
                                                </select>
                                            </div>
                                            {reminders.frequency === 'Weekly'
                                                ? <div className='mb-3 col-md-4 ml-4'>
                                                    <label htmlFor='day' className='form-label'>Week Day</label>
                                                    <select
                                                        className='form-select input-field'
                                                        id='day'
                                                        value={reminders.day}
                                                        onChange={(e) => handleReminderChange(e)}
                                                    >
                                                        <option value=''>Select Day</option>
                                                        <option value='Monday'>Monday</option>
                                                        <option value='Tuesday'>Tuesday</option>
                                                        <option value='Wednesday'>Wednesday</option>
                                                        <option value='Thursday'>Thursday</option>
                                                        <option value='Friday'>Friday</option>
                                                        <option value='Saturday'>Saturday</option>
                                                        <option value='Sunday'>Sunday</option>
                                                    </select>
                                                </div>
                                                : null
                                            }
                                        </div>
                                        <div className='mb-3 col-md-8'>
                                            <label htmlFor='message' className='form-label'>Message</label>
                                            <textarea
                                                className='form-control input-field'
                                                id='message'
                                                rows='3'
                                                value={reminders.message}
                                                onChange={(e) => handleReminderChange(e)}
                                            />
                                        </div>
                                        <div className='d-flex justify-content-between'>
                                            {messageShow === 'error' && <p className='update-name-error'>{reminderMessage}</p>}
                                        </div>
                                        <div className='d-flex justify-content-between col-md-8'>
                                            <button type='button' className='btn btn-secondary save-btn' onClick={() => handleSave()}>Save</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            }
                        </div>
                        : null
                    }
                </div>
            </div>
        </>
    );
}
